import { render, staticRenderFns } from "./WordSearch.vue?vue&type=template&id=b87bc44c&scoped=true"
import script from "./WordSearch.js?vue&type=script&lang=js&external"
export * from "./WordSearch.js?vue&type=script&lang=js&external"
import style0 from "./WordSearch.vue?vue&type=style&index=0&id=b87bc44c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87bc44c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
